// Small display helpers shared by page components. They intentionally avoid
// Vue state so pages can import them without creating hidden dependencies.
export function jobDisplayLabel(job) {
  if (!job) {
    return "未填写描述";
  }
  return job.step_desc || "未填写描述";
}

export function jobOptionLabel(job) {
  return jobDisplayLabel(job);
}

export function ruleJobOptionLabel(job) {
  if (!job) {
    return "未填写描述";
  }
  const description = job.step_desc || "未填写描述";
  return job.step ? `Step ${job.step} - ${description}` : description;
}

export function flowJobOptionLabel(job) {
  return ruleJobOptionLabel(job);
}

export function flowChainLabel(flow) {
  if (!flow || !Array.isArray(flow.jobs) || !flow.jobs.length) {
    return "暂无绑定 Step";
  }
  return flow.jobs.map((job) => flowJobOptionLabel(job)).join(" -> ");
}

export function formatDateTime(value) {
  if (!value) {
    return "-";
  }
  // Backend timestamps are MySQL values serialized without timezone; keep the
  // literal time instead of shifting it through the browser timezone parser.
  return String(value).replace("T", " ").replace(/\.\d+$/, "").slice(0, 19);
}

export function methodTagType(method) {
  return {
    GET: "",
    POST: "success",
    PUT: "warning",
    PATCH: "info",
    DELETE: "danger",
  }[method || "GET"];
}

export function blockLabel(job) {
  return Number(job.return_rule_end) === 0 ? "断言失败不阻塞" : "断言失败阻塞";
}

export function parseLastResponse(job) {
  if (!job || !job.last_response) {
    return null;
  }
  try {
    return JSON.parse(job.last_response);
  } catch (error) {
    return null;
  }
}

export function assertionLabel(job) {
  const result = parseLastResponse(job);
  if (!result || !result.assertion || result.assertion.skipped) {
    return "";
  }
  if (!result.assertion.ok && result.assertion.block_flow === false) {
    return "断言失败(不阻塞)";
  }
  return result.assertion.ok ? "断言通过" : "断言失败";
}

export function assertionTagType(job) {
  const result = parseLastResponse(job);
  if (!result || !result.assertion || result.assertion.skipped) {
    return "info";
  }
  return result.assertion.ok ? "success" : "danger";
}
